module.exports = __webpack_public_path__ + "img/int-white.1684d894.svg";